function moveFocusToCartSlide() {
  var menuButton = document.getElementById('header-cart')
  var closeButton = document.getElementById('cart-close')
  var addButton = document.getElementById('addtocart')

  addButton.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' || event.key === ' ') {
      this.click()
      var cartSlide = document.querySelector('.ajax-cart-box')
      cartSlide.focus()
    }
  });

    menuButton.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' || event.key === ' ') {
      this.click()
      var cartSlide = document.querySelector('.ajax-cart-box')
      cartSlide.focus()
    }
  });

  closeButton.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' || event.key === ' ') {
      this.click()
      menuButton.focus()
    }
  })
}

window.addEventListener('load', function () {
  moveFocusToCartSlide()
})

document.addEventListener('DOMContentLoaded', function () {
  // Images
  var images = document.querySelectorAll('img:not([alt])')
  for (var i = 0; i < images.length; i++) {
    var altimage = images[i]
    altimage.setAttribute('alt', '')
  }

  // Accordions
  var accordionHeaders = document.querySelectorAll('.accordion-section-header')

  accordionHeaders.forEach(function (header) {
    header.addEventListener('click', function () {
      var expanded = this.getAttribute('aria-expanded') === 'true' || false
      this.setAttribute('aria-expanded', !expanded)
    })

    header.addEventListener('keypress', function (event) {
      if (event.keyCode === 13) {
        var expanded = this.getAttribute('aria-expanded') === 'true' || false
        this.click()
        this.setAttribute('aria-expanded', !expanded)
      }
    })
  })

  // Skip link
  var skipLink = document.querySelector('.skip-link')
  skipLink.addEventListener('keydown', function (event) {
    if (event.keyCode === 13) {
      event.preventDefault()
      var targetId = skipLink.getAttribute('href').substring(1)
      var targetElement = document.getElementById(targetId)
      if (targetElement) {
        targetElement.focus()
      }
    }
  })

  var inputField = document.querySelector('#scDiscountApp input[type="text"]')
  if (inputField) inputField.setAttribute('aria-label', 'Discount code or gift card')

  var viewportMeta = document.querySelector('meta[name="viewport"]')
  if (viewportMeta) {
    viewportMeta.setAttribute('content', 'width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=5')
  }
})
